module.exports = __webpack_public_path__ + "img/tem-saude.54682520.png";